import { useState, useEffect, useMemo, useRef } from "react";
import "./styles.css";

export default function Countdown({ onComplete }) {
    const target = useMemo(() => new Date("2026-11-21T12:00:00-06:00"), []);
    const [t, setT] = useState(() => target - new Date());
    const done = t <= 0;
    const firedRef = useRef(false);

    useEffect(() => {
        if (done && onComplete && !firedRef.current) {
            firedRef.current = true;
            onComplete();
        }
    }, [done, onComplete]);

    useEffect(() => {
        const id = setInterval(() => setT(target - new Date()), 1000);
        return () => clearInterval(id);
    }, [target]);

    const ms = Math.max(0, t);
    const days = Math.floor(ms / 86400000);
    const hours = Math.floor((ms % 86400000) / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);

    return (
      <section className="countdown-section">
        <div className="countdown-container">
          <div className="time-box">
            <span className="time-number">{days.toString().padStart(2, "0")}</span>
            <span className="time-label">Días</span>
          </div>
          <span className="separator">-</span>
          <div className="time-box">
            <span className="time-number">{hours.toString().padStart(2, "0")}</span>
            <span className="time-label">Horas</span>
          </div>
          <span className="separator">:</span>
          <div className="time-box">
            <span className="time-number">{minutes.toString().padStart(2, "0")}</span>
            <span className="time-label">Min.</span>
          </div>
          <span className="separator">:</span>
          <div className="time-box">
            <span className="time-number">{seconds.toString().padStart(2, "0")}</span>
            <span className="time-label">Seg.</span>
          </div>
        </div>
      </section>
    );
}